import React from "../../__snowpack__/pkg/react.js";
const ROUND_ICON_MAP = {
  KEEPPACK: "/images/icon-warehouse-round/keeppack.svg",
  GINEE: "/images/icon-warehouse-round/ginee.svg",
  GINEE_LOCAL: "/images/icon-warehouse-round/ginee-local.png",
  FASTOCK: "/images/icon-warehouse-round/fastock.png",
  JD: "/images/icon-warehouse-round/jd.id.jpeg",
  YUEHAI: "/images/icon-warehouse-round/yh.png",
  YILIAN: "/images/icon-warehouse-round/yilian.png",
  GINEE_WMS: "/images/icon-warehouse-round/wms.png",
  JITU: "/images/icon-warehouse-round/J&t.png",
  SHOPEE: "/images/icon-warehouse-round/shopee.png",
  SHIPPER: "/images/icon-warehouse-round/warehouse.png",
  YICANG: "/images/icon-warehouse-round/yicang.png",
  OTHER: "/images/icon-warehouse-round/other.jpeg"
};
const ICONS_MAP = {
  round: ROUND_ICON_MAP
};
export default function ChannelIcon(props) {
  const {provider, type = "round", ...imgProps} = props;
  const src = ICONS_MAP[type][provider] ?? ICONS_MAP[type]?.OTHER;
  return /* @__PURE__ */ React.createElement("img", {
    src,
    ...imgProps,
    style: {
      display: "inline-block",
      width: 14,
      height: 14,
      ...imgProps.style
    }
  });
}
